import React from 'react';
import { getContext } from 'common';
import FloatingPanelButtons from 'components/FloatingPanel/FloatingPanelButtons';
import _merge from 'lodash/merge';
import Styled from './styles';

/* used by 'react-rnd' as the drag/move handle */
export const HEADER_CLASSNAME = 'ccfk-floatingpanel-header';

export interface FloatingPanelHeaderProps extends React.ComponentPropsWithRef<'div'> {
  /** Content of FloatingPanelHeader */
  children?: React.ReactNode;
  /** Place action buttons content here. */
  renderButtons?: React.ReactNode;
  /** Toggles showing the divider between header and content area. */
  divider?: boolean;
  /** To override the theme please refer to the "Readme" tab to learn more. */
  theme?: any;
}

/** FloatingPanelHeader component, place title and action buttons here. */
const FloatingPanelHeader = React.forwardRef<HTMLElement, FloatingPanelHeaderProps>((props: FloatingPanelHeaderProps, ref) =>
  getContext(({ RTL, theme }) => {
    const { children, renderButtons, theme: propTheme, divider, ...otherProps } = props;
    const resolvedTheme = _merge({}, theme.FLOATING_PANEL, propTheme);
    return (
      <Styled.FloatingPanelHeaderContainer className={HEADER_CLASSNAME} $rtl={RTL} $theme={resolvedTheme} $divider={divider}>
        <Styled.FloatingPanelHeader $rtl={RTL} ref={ref} {...otherProps}>
          {children}
        </Styled.FloatingPanelHeader>
        {renderButtons && <FloatingPanelButtons>{renderButtons}</FloatingPanelButtons>}
      </Styled.FloatingPanelHeaderContainer>
    );
  }));

FloatingPanelHeader.displayName = 'FloatingPanelHeader';

FloatingPanelHeader.defaultProps = {
  children: undefined,
  renderButtons: undefined,
  divider: true,
  theme: {},
};

export default FloatingPanelHeader;
